import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/ramos';

export const cargarRamos = async (index = null) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const API_URL_AUX = index===null ? `${API_URL}/listar`: `${API_URL}/listar?compania=${index}` ;
      const response = await fetch(API_URL_AUX, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error('Error al cargar los ramos');
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const obtenerRamo = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/obtener_compania?id=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Error al obtener el cliente: ${id}`);
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const crearRamo = async (formData, compania, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "nombre" : formData.nombre, "compania" : compania, "creador" : creador}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarRamo = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id": formData.id, "nombre" : formData.nombre, "editor" : editor}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarRamo = async (id, editor) => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};